import axios from 'axios';
import Button from 'components/CustomButton/CustomButton.jsx';
import immutable from 'object-path-immutable';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import WidgetSearchName from '../../Clients/widget-searchName';
import * as QuotationsActions from '../redux/QuotationsActions';
import InputMask from 'react-input-mask';

class clientInformation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: props.match.params.id,
      optionsSelect: {
        clients: [],
      },
      sendEmailText: 'ENVIAR EMAIL',
      sendingEmail: false,
      sendingButton: 'primary',
      franchiseInfo: {
        CTZ: '',
        REC: '',
        VTA: '',
        F: '',
        address: {
          street: '',
          extNumber: '',
          intNumber: '',
          suburb: '',
          zipcode: '',
        },
        email: '',
        id: '',
        name: '',
        owner: '',
        phone: '',
      },
    };
    this.labelSaludation = [
      'Sr.',
      'Sra.',
      'Srta.',
      'Joven',
      'Dr.',
      'Lic.',
      'Arq.',
      'Ing.',
      'Mtro.',
    ];
  }

  async componentWillMount() {
    //console.log("Props", this.props.onSubmit);
    let { Quotations } = this.props;
    const url =
      process.env.REACT_APP_URL_API +
      '/api/franchises?filter={"where":{"id":"' +
      Quotations.clientInformation.franchiseId +
      '"}}';
    var franchise = await axios.get(url);
    this.setState({
      franchiseInfo: franchise.data[0],
    });
  }

  onRedirect = async () => {
    let { Quotations } = this.props;
    window.open('#/admin/clients/' + Quotations.clientInformation.id, '_blank');
  };

  getOptionsSelect = async (name, url, optionCreateFunction) => {
    var response = await axios.get(url);
    var options = [];
    response.data.map((option) => {
      options.push(optionCreateFunction(option));
    });
    this.setState({
      optionsSelect: {
        ...this.state.optionsSelect,
        [name]: options,
      },
      clients: response.data,
    });
  };

  selectClient = (event) => {
    var clientInformation = this.state.clients.filter(
      (o) => o.id === event.value
    );
    var newClientInformation = immutable.set(
      this.props.Quotations,
      'clientInformation',
      clientInformation[0]
    );
    this.props.dispatch(QuotationsActions.setState(newClientInformation));
  };

  goWhatsApp = async (quotationId, name, saludation, telephone, assignedTo) => {
    let quotationDate = await this.props.onSubmit('sended');
    this.props.history.push('/admin/quotations/' + quotationDate.data.id);
    quotationId = quotationDate.data.id;

    const params = {
      fields: {
        emailConfiguration: false,
        roles: false,
        firstName: true,
        lastName: true,
        id: true,
      },
    };
    let userData = await axios.get(
      process.env.REACT_APP_URL_API +
        '/api/users/' +
        assignedTo +
        '?filter=' +
        JSON.stringify(params)
    );

    telephone = telephone.replace(/\s/g, '');
    //DONE Paty  - Quitar el undefined cuando no hay Sr, sra, etc.

    telephone = telephone.replace(/\s/g, '');

    const url =
      'https://api.whatsapp.com/send?phone=521' +
      telephone +
      '&text=Hola ' +
      (saludation !== undefined ? saludation + ' ' : '') +
      name +
      ' soy ' +
      (userData.data.firstName !== undefined ? userData.data.firstName : '') +
      ' ' +
      (userData.data.lastName !== undefined ? userData.data.lastName : '') +
      ' de RS Viajes ' +
      (this.state.franchiseInfo.name !== undefined
        ? encodeURIComponent(this.state.franchiseInfo.name)
        : '') +
      '. Con gusto enviamos la cotización solicitada esperando que sea de su agrado, no dude en comunicarse con nosotros. Para ver el contenido favor de dar click en el siguiente enlace ' +
      ' ' +
      process.env.REACT_APP_URL_PUBLIC +
      '/quotation/' +
      quotationId;

    var link = document.createElementNS('http://www.w3.org/1999/xhtml', 'a');
    link.href = url;
    link.target = '_blank';
    var event = new MouseEvent('click', {
      view: window,
      bubbles: false,
      cancelable: true,
    });
    link.dispatchEvent(event);
  };

  sendEmail = async () => {
    if (this.state.sendingEmail === false) {
      let quotationDate = await this.props.onSubmit('sended');
      this.props.history.push('/admin/quotations/' + quotationDate.data.id);

      this.setState({
        sendEmailText: 'ENVIANDO ...',
        sendingEmail: true,
        sendingButton: 'default',
      });

      var sendedEmail = await axios.post(
        process.env.REACT_APP_URL_API + '/email-quotation',
        {
          id: quotationDate.data.id,
        }
      );

      if (sendedEmail.data.sended === true) {
        this.setState({
          sendEmailText: '¡ENVIADO CORRECTAMENTE!',
          sendingButton: 'success',
        });

        setTimeout(() => {
          this.setState({
            sendEmailText: 'ENVIAR EMAIL',
            sendingEmail: false,
            sendingButton: 'primary',
          });
        }, 2000);
      } else {
        this.setState({
          sendEmailText: sendedEmail.data.message,
          sendingButton: 'danger',
        });

        setTimeout(() => {
          this.setState({
            sendEmailText: 'ENVIAR EMAIL',
            sendingEmail: false,
            sendingButton: 'primary',
          });
        }, 5000);
      }

      console.log('Email Enviado', sendedEmail);
    }
  };

  openQuotation = async () => {
    let { Quotations } = this.props;
    console.log('Quotations', Quotations);
    let quotationDate = await this.props.onSubmit();
    this.props.history.push('/admin/quotations/' + quotationDate.data.id);

    let url =
      process.env.REACT_APP_URL_PUBLIC + '/quotation/' + quotationDate.data.id;

    let link = document.createElementNS('http://www.w3.org/1999/xhtml', 'a');
    link.href = url;
    link.target = '_blank';
    let event = new MouseEvent('click', {
      view: window,
      bubbles: false,
      cancelable: true,
    });
    link.dispatchEvent(event);
  };

  onChangeWidgetSearch = async (value) => {
    var ClientInformationReturn = await axios.get(
      process.env.REACT_APP_URL_API + '/api/clients/' + value
    );
    var newClientInformation = immutable.set(
      this.props.Quotations,
      'clientInformation',
      ClientInformationReturn.data
    );
    newClientInformation = immutable.set(
      newClientInformation,
      'clientId',
      value
    );
    this.props.dispatch(QuotationsActions.setState(newClientInformation));
  };

  onCreateWidgetSearch = () => {
    window.open('/#/admin/clients/create', '_blank');
  };

  render() {
    const { Quotations } = this.props;
    return (
      <div>
        {Quotations.clientId !== undefined ? (
          <a
            style={{ fontWeight: 'bold', float: 'right' }}
            onClick={this.onRedirect}
            target="_blank"
          >
            VER PERFIL
          </a>
        ) : null}

        <div className="form-group">
          <label htmlFor="client">Cliente</label>

          <WidgetSearchName
            schema={{
              creatable: false,
              title: 'Buscar cliente por nombre, telefono o correo',
              api: process.env.REACT_APP_URL_API + '/api/clients',
            }}
            value={Quotations.clientId}
            defaultOptions={Quotations.optionsSelect.client}
            required={true}
            onChange={this.onChangeWidgetSearch}
            onCreate={this.onCreateWidgetSearch}
          />

          <input
            style={{
              height: 1,
              padding: 0,
              margin: 0,
              border: 0,
              color: 'white',
            }}
            required={true}
            type="text"
            id="userIdHidden"
            value={Quotations.clientId}
            readOnly={true}
          />
        </div>

        {Quotations.clientId !== undefined ? (
          <div>
            <div className="form-group">
              <label htmlFor="phone">Teléfono celular</label>
              <InputMask
                mask="9999 99 99 99"
                required
                type="text"
                className="form-control"
                id="phone"
                value={Quotations.clientInformation.phone}
                onChange={(event) =>
                  this.props.dispatch(
                    QuotationsActions.onChange(
                      ['clientInformation', 'phone'],
                      event.target.value
                    )
                  )
                }
              />
            </div>

            <div className="form-group">
              <label htmlFor="email">Email</label>
              <input
                type="text"
                className="form-control"
                id="email"
                value={Quotations.clientInformation.email}
                onChange={(event) =>
                  this.props.dispatch(
                    QuotationsActions.onChange(
                      ['clientInformation', 'email'],
                      event.target.value
                    )
                  )
                }
              />
            </div>
            <div className="form-group">
              <label htmlFor="notes">Notas del cliente</label>
              <textarea
                type="text"
                className="form-control"
                id="notes"
                value={Quotations.clientInformation.notes}
                onChange={(event) =>
                  this.props.dispatch(
                    QuotationsActions.onChange(
                      ['clientInformation', 'notes'],
                      event.target.value
                    )
                  )
                }
              />
            </div>
          </div>
        ) : null}

        {Quotations.clientInformation.id !== undefined ? (
          <div>
            <div className="form-group">
              <Button
                bsStyle={this.state.sendingButton}
                wd
                style={{ width: '100%' }}
                onClick={this.sendEmail}
              >
                {this.state.sendEmailText}
              </Button>
            </div>
            <div className="form-group">
              <Button
                bsStyle="primary"
                wd
                style={{ width: '100%' }}
                onClick={() =>
                  this.goWhatsApp(
                    Quotations.id,
                    Quotations.clientInformation.firstName,
                    Quotations.clientInformation.saludation,
                    Quotations.clientInformation.phone,
                    Quotations.generalQuotation.userId
                  )
                }
              >
                ENVIAR WHATSAPP
              </Button>
            </div>
            <div className="form-group">
              <Button
                bsStyle="primary"
                wd
                style={{ width: '100%' }}
                onClick={this.openQuotation}
                href={
                  process.env.REACT_APP_URL_PUBLIC +
                  '/quotation/' +
                  this.state.id
                }
              >
                VER COTIZACIÓN
              </Button>
            </div>
          </div>
        ) : null}
      </div>
    );
  }
}

export default connect((state) => ({ Quotations: state.Quotations }))(
  clientInformation
);



// WEBPACK FOOTER //
// ./src/views/Quotations/cards/clientInformation.js